// componente che contiene i metodi di show e hide loader, ovvero visualizzazione e rimozione dell'animazione
// di caricamento durante l'esecuzione di un task 

import { Injectable } from '@angular/core';
import _ from 'lodash';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class UtilsService {

    constructor(
        private uiLoaderService: NgxUiLoaderService,
    ) {
    }

    showLoader(id?: string) {
        this.uiLoaderService.start(id);
    }

    hideLoader(id?: string) {
        this.uiLoaderService.stop(id);
    }
}
